import { render } from "./about_page.vue?vue&type=template&id=a1a1e220&scoped=true"
import script from "./about_page.vue?vue&type=script&lang=js"
export * from "./about_page.vue?vue&type=script&lang=js"

import "./about_page.vue?vue&type=style&index=0&id=a1a1e220&lang=css"
import "./about_page.vue?vue&type=style&index=1&id=a1a1e220&scoped=true&lang=css"

import exportComponent from "/Users/danramage/Documents/workspace/WaterQuality/WaterQualityFrontEnd_Vue3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1a1e220"]])

export default __exports__